import { Button, ModalBody, Modal, ModalHeader } from "reactstrap";
import "../../components/layout/Leads/Leads.scss";
import ModalCloseIcon from "../../images/modal-close.svg";
import checkIcon from "../../images/checkGreen.png";
interface IProps {
  confirmCloseHandle: (closeTag: boolean) => void;
  confirmCloseModel: boolean;
  confirmText: string;
  className?: string;
  headerText?: string;
  modalToggle?: () => void;
}

const ToasterPopUp = (props: IProps) => {
  const closeBtn = (
    <button
      className="close"
      onClick={() => props.confirmCloseHandle(false)}
      type="button"
    >
      <img src={ModalCloseIcon} alt="ModalCloseIcon" />
    </button>
  );
  return (
    <Modal
      isOpen={props.confirmCloseModel}
      className={`ToasterPopUp ${props.className}`}
      toggle={props.modalToggle}
    >
      {props.headerText && (
        <ModalHeader close={closeBtn}>
          <img src={checkIcon} alt="check-icon" className="checkGreen" />
          {props.headerText}
        </ModalHeader>
      )}
      <ModalBody>
        <div className="options">
          <h4>{props.confirmText}</h4>
          <Button
            className="yes"
            onClick={() => props.confirmCloseHandle(true)}
          >
            Yes
          </Button>
          <Button
            className="no"
            onClick={() => props.confirmCloseHandle(false)}
          >
            No
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ToasterPopUp;
